function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import TextBox from './TextBox';
import { IconButton } from '../buttons';
import { VisibilityIconOff, VisibilityIconOn } from '../icons';
import '../assets/inputFields.css';
const PasswordBox = _ref => {
  let {
    label,
    name,
    ...rest
  } = _ref;
  const [showVisibilityOn, setShowVisibilityOn] = useState(false);
  const getToggleButton = () => /*#__PURE__*/React.createElement(IconButton, {
    onClick: () => setShowVisibilityOn(!showVisibilityOn),
    icon: showVisibilityOn ? VisibilityIconOn : VisibilityIconOff
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextBox, _extends({}, rest, {
    type: showVisibilityOn ? 'text' : 'password',
    name: name,
    label: label,
    endAdornmentText: getToggleButton(),
    required: true
  })));
};
PasswordBox.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  email: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  elKey: PropTypes.any
};
export default PasswordBox;